import React from 'react';

/** Retail-style tiles: bold color + product image (Unsplash). Not affiliated with any retailer. */
const TILES = [
  {
    category: 'All',
    label: 'Shop all',
    img: 'https://images.unsplash.com/photo-1607082348824-0a96f2a48b28?w=400&q=80&auto=format&fit=crop',
    gradient: 'from-violet-600 to-purple-800'
  },
  {
    category: 'Computer Parts',
    label: 'Computer parts',
    img: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=400&q=80&auto=format&fit=crop',
    gradient: 'from-[#5c2d91] to-purple-900'
  },
  {
    category: 'PisoWiFi/PisoNet',
    label: 'Piso WiFi',
    img: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&q=80&auto=format&fit=crop',
    gradient: 'from-[#8cc63f] to-emerald-700'
  },
  {
    category: 'CCTV Products',
    label: 'CCTV',
    img: 'https://images.unsplash.com/photo-1557597774-9d273605dfa9?w=400&q=80&auto=format&fit=crop',
    gradient: 'from-sky-500 to-blue-700'
  },
  {
    category: 'Fiber Products',
    label: 'Fiber',
    img: 'https://images.unsplash.com/photo-1544197150-b99d580f7bb0?w=400&q=80&auto=format&fit=crop',
    gradient: 'from-lime-500 to-green-800'
  },
  {
    category: 'Solar Products',
    label: 'Solar',
    img: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=400&q=80&auto=format&fit=crop',
    gradient: 'from-amber-500 to-orange-700'
  }
];

export default function CategoryShowcase({ selectedCategory, onSelectCategory, productCounts }) {
  return (
    <section className="space-y-4" aria-labelledby="category-showcase-heading">
      <h2 id="category-showcase-heading" className="sr-only">
        Popular categories
      </h2>
      <ul className="grid grid-cols-3 gap-2 sm:grid-cols-3 sm:gap-4 lg:grid-cols-6">
        {TILES.map((tile) => {
          const active = selectedCategory === tile.category;
          const count =
            tile.category === 'All' ? productCounts.all : productCounts.byCategory[tile.category] ?? 0;
          return (
            <li key={tile.category}>
              <button
                type="button"
                onClick={() => onSelectCategory(tile.category)}
                className={`group flex w-full flex-col items-center touch-manipulation ${
                  active ? 'ring-2 ring-[#8cc63f] ring-offset-2 rounded-2xl sm:rounded-3xl' : ''
                }`}
              >
                <div
                  className={`relative mx-auto flex aspect-square w-full max-w-[118px] items-center justify-center overflow-hidden rounded-2xl bg-gradient-to-br p-2.5 shadow-md transition hover:shadow-xl sm:max-w-[200px] sm:rounded-3xl sm:p-4 ${tile.gradient}`}
                >
                  <img
                    src={tile.img}
                    alt=""
                    className="max-h-[72%] max-w-[86%] object-contain drop-shadow-lg transition duration-300 group-hover:scale-105 sm:max-h-[75%]"
                    loading="lazy"
                    decoding="async"
                  />
                  {count > 0 ? (
                    <span className="absolute right-1.5 top-1.5 rounded-full bg-white/90 px-1.5 py-0.5 text-[9px] font-bold text-slate-800 shadow sm:right-2 sm:top-2 sm:px-2 sm:text-[10px]">
                      {count}
                    </span>
                  ) : null}
                </div>
                <span className="mt-1.5 max-w-[7rem] text-center text-[10px] font-bold uppercase leading-tight tracking-wide text-slate-800 sm:mt-2 sm:max-w-[10rem] sm:text-xs">
                  {tile.label}
                </span>
              </button>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
